import { Injectable, Inject } from "@angular/core";
import * as Immutable from "immutable";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { HttpService } from "../../shared/providers"
import { AccountDataRequest, ApiResponse, DealerControlPanelRequest } from "../shared/models";
import { ApiResponseBuilder } from "../shared/providers/apiResponseBuilder";
import { BaseController } from "../shared/providers/baseController";

@Injectable()
export class DealerControlPanelController extends BaseController {
  public getControllerUrl(): string {
    return this.dealerControlPanelControllerUrl;
  }

  protected dealerControlPanelControllerUrl = "api/dealercontrolpanel";

  constructor(
    @Inject(HttpService) public httpService: HttpService,
    public apiResponseBuilder: ApiResponseBuilder
  ) {
    super(httpService, apiResponseBuilder);
  }

  public buildResponseObject = map((response, index) => this.apiResponseBuilder.build(response));
  
  public get(requestModel: DealerControlPanelRequest): Observable<ApiResponse> {
    return this.httpService.post(this.dealerControlPanelControllerUrl, requestModel).pipe(this.buildResponseObject);
  }
  
}